import { memo } from "react";
import Box, { type BoxProps } from "@mui/material/Box";
import { useOnboardingStep, type WithStep } from "../../hooks";

const Stats = ({ route, getApplicationModel, ...restProps }: WithStep<BoxProps>) => {
    const {
        getCompletedStepsCount,
        getTotalStepsCount
    } = useOnboardingStep({
        route,
        getApplicationModel
    });

    return (
        <Box
            {...restProps}
            sx={{
                fontWeight: 600,
                color: 'common.black',
                ...restProps.sx
            }}
        >
            {getCompletedStepsCount()} / {getTotalStepsCount()} Steps Completed
        </Box>
    );
};

export default memo(Stats);
